/**
 * @format
 * @flow
 */
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as RT from '../../../constants/Routing';
import * as Actions from '../../../actions/Setting';

import Modal from '../../../components/Common/Modal';
import Template from '../../../components/Template/AfterLoginTemplate';
import { getEnterpriseCategories } from '../../../db/categories';
import { addressFromPostalCode, validRange, parseDate } from '../../../lib/function';
import { loadStart, loadEnd } from '../../../actions/App';
import TimeRange from 'react-time-range';
import Tooltip from 'react-simple-tooltip';
import generateCalendarHash from '../../../lib/generate_calendar_hash';
import DateJp from 'UltraDate.js';
import Moment from 'moment';
DateJp.setDefaultLocale('ja');

class Component extends React.Component {
  constructor(props) {
    super(props);
    // ///////////////////////
    const year = new DateJp().addDate(2).getFullYear();
    const month = `0${new DateJp().addDate(2).getMonth() + 1}`.slice(-2);
    const date = `0${new DateJp().addDate(2).getDate()}`.slice(-2);
    this.state = {
      allValid: false,
      formErrors: {
        categoryId: '',
        email: '',
        image: '',
        description: '',
        enterpriseName: '',
        postCode: '',
        email: '',
        prefecture: '',
        city: '',
        block: '',
        street: '',
        phone: '',
        way: '',
        workTime: '',
        street: '',
        stationName: '',
        picTitle: '',
        picName: '',
        nonBusinessHour: '',
        chargePersonName: '',
        contractName: '',
        serviceUsed: ''
      },
      // ////////////////////////
      loaded: false,
      setting: this.props.Setting.currentSetting,
      categories: [],
      currentCategory: '',
      categories: '',
      categoryId: '',
      categoryName: '',
      // ///////////////////////
      image: '',
      description: '',
      enterpriseName: '',
      postCode: '',
      email: '',
      prefecture: '',
      city: '',
      block: '',
      street: '',
      phone: '',
      way: '',
      workTime: '',
      street: '',
      stationName: '',
      picTitle: '',
      picName: '',
      nonBusinessHour: '',
      chargePersonName: '',
      // ///////////////////////
      categoryValid: '',
      emailValid: '',
      imageValid: '',
      descriptionValid: '',
      enterpriseNameValid: '',
      postCodeValid: '',
      emailValid: '',
      prefectureValid: '',
      cityValid: '',
      blockValid: '',
      streetValid: '',
      phoneValid: '',
      wayValid: '',
      workTimeValid: '',
      streetValid: '',
      stationNameValid: '',
      picTitleValid: '',
      picNameValid: '',
      nonBusinessHourValid: '',
      chargePersonNameValid: '',
      setting: this.props.Setting.currentSetting,
      categories: [],
      currentCategory: '',
      startTime: Moment('10:00', 'HH:mm'),
      endTime: Moment('18:00', 'HH:mm'),
      pageTab: 1,
      allValidPlan: false,
      contractName: '',
      serviceUsed: '',
      months: generateCalendarHash.generateMonths(),
      years: generateCalendarHash.generateYears(),
      days: generateCalendarHash.generateDaysForSetting(),
      start_year: year,
      start_month: month,
      start_date: date
    };
    this.currentUser = JSON.parse(localStorage.getItem('current_user'));
    this.setValue = this.setValue.bind(this);
  }

  componentDidMount() {
    loadStart();
    const token = this.currentUser.accessToken;
    const { enterpriseId } = this.currentUser;
    this.props.getSetting(enterpriseId, token, this.currentUser.email);
  }

  componentWillReceiveProps = props => {
    if (this.props.Setting.currentSettingLoaded) {
      console.log('TCL: this.props.Setting', this.props.Setting);
      const {
        enterpriseName,
        postalCode = postalCode.trim(),
        email,
        prefecture,
        municipality,
        block,
        street,
        phone,
        way,
        workTime = workTime.trim(),
        description,
        image,
        stationName,
        picTitle,
        picName,
        locDescription,
        enterprisePhotoId,
        enterpriseCategory,
        nonBusinessHour,
        chargePersonName,
        contractName,
        contractStartDate,
        serviceUsed
      } = props.Setting.currentSetting;
      console.log('TCL: Component -> props.Setting.currentSetting', props.Setting.currentSetting);
      const categoryObj = props.Setting.categories.find(cat => cat.value === enterpriseCategory);
      var time = workTime.split('-');

      var contractDate = parseDate(contractStartDate);

      this.setState({
        load_end: true,
        enterpriseName,
        postCode: postalCode !== ' ' ? postalCode : '',
        email,
        prefecture,
        city: municipality,
        block: locDescription,
        street,
        phone: phone !== ' ' ? phone : '',
        way,
        workTime,
        description,
        image: enterprisePhotoId !== ' ' ? enterprisePhotoId : '',
        stationName,
        picTitle,
        picName,
        categoryId: categoryObj ? categoryObj.key : '0',
        categories: props.Setting.categories,
        nonBusinessHour,
        chargePersonName,
        startTime: time[0] !== ' ' ? Moment(time[0], 'HH:mm') : Moment('10:00', 'HH:mm'),
        endTime: time[0] !== ' ' ? Moment(time[1], 'HH:mm') : Moment('18:00', 'HH:mm'),
        allValid: categoryObj ? true : false,
        workTimeValid: time[0] ? true : false,
        pageTab: this.state.pageTab,
        contractName,
        start_year: contractDate.year,
        start_month: contractDate.month,
        start_date: contractDate.day,
        serviceUsed,
        allValidPlan: !(contractName !== '' && serviceUsed !== '')
      });
      //  this._getCategoryName(this.state.setting.enterpriseCategory);
    }
  };

  _getCategoryName = key => {
    if (!this.state.categories.length || this.state.categories.length === 0) return;
    console.log('TCL: Component -> this.state.categories', this.state.categories);

    const categoryObj = this.state.categories.find(cat => cat.value === key);
    if (categoryObj !== undefined && categoryObj.value.length !== 0) {
      this.setState({ currentCategory: categoryObj.value });
    }
  };

  renderEnterpriseCategoriesOptions = categories => {
    console.log('TCL: categories', categories);
    if (categories.length === 0) {
      return;
    }
    return categories.map(cat => {
      return (
        <option value={cat.key} key={cat.key}>
          {cat.value}
        </option>
      );
    });
  };

  setValue(e) {
    console.log('TCL: setValue -> e', e.target.value, e.target.name);
    const re = /^[0-9\b]+$/;
    const workTime = /^(?=.*?[0-9])[0-9()-:]+$/;
    const feeRateRegx = /^[0-5()]+$/;

    if (e.target.name === 'postCode' && re.test(e.target.value) === true) {
      this.parsePostalCode(e);
      this.fillValue(e.target.name, e.target.value);
    } else if (
      e.target.value === '' ||
      (e.target.name === 'phone' && re.test(e.target.value) === true)
    ) {
      this.fillValue(e.target.name, e.target.value);
    } else if (
      e.target.value === '' ||
      (e.target.name === 'workTime' && workTime.test(e.target.value) === true)
    ) {
      this.fillValue(e.target.name, e.target.value);
    } else {
      return e.target.name.includes('postCode')
        ? ''
        : e.target.name.includes('phone')
          ? ''
          : e.target.name.includes('workTime')
            ? ''
            : this.fillValue(e.target.name, e.target.value);
    }
  }

  fillValue(name, value) {
    this.setState({ [name]: value }, () => {
      this._validateField(name, value);
    });
  }

  _validateField = (fieldName, value) => {
    let {
      formErrors,
      categoryValid,
      enterpriseNameValid,
      postCodeValid,
      emailValid,
      prefectureValid,
      cityValid,
      blockValid,
      streetValid,
      phoneValid,
      wayValid,
      workTimeValid,
      descriptionValid,
      imageValid,
      categoryId,
      picTitleValid,
      picNameValid,
      stationNameValid,
      nonBusinessHourValid,
      chargePersonNameValid,
      enterpriseName,
      postCode,
      email,
      prefecture,
      city,
      block,
      street,
      phone,
      way,
      workTime,
      description,
      image,
      stationName,
      picTitle,
      picName,
      nonBusinessHour,
      chargePersonName
    } = this.state;
    const fieldValidationErrors = formErrors;

    switch (fieldName) {
      case 'categoryId':
        categoryValid = !!categoryId;
        fieldValidationErrors.categoryId = categoryValid ? '' : 'カテゴリーを選択してください';
        break;
      case 'enterpriseName':
        enterpriseNameValid = !!enterpriseName;
        fieldValidationErrors.enterpriseName = enterpriseNameValid
          ? enterpriseName.length < 6
            ? '６文字以上を入力してください'
            : ''
          : '事業者名を入力してください';
        break;
      case 'postCode':
        postCodeValid = !!postCode;
        fieldValidationErrors.postCode = postCodeValid
          ? postCode.length < 7
            ? '７桁数字を入力してください'
            : ''
          : '郵便番号を入力してください';
        break;
      case 'street':
        streetValid = !!street;
        fieldValidationErrors.street = streetValid ? '' : '住所を入力してください';
        break;
      case 'email':
        emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        fieldValidationErrors.email = emailValid ? '' : '無効なメールアドレス';
        break;
      case 'phone':
        phoneValid = phone.length >= 10 && phone.length <= 11;
        fieldValidationErrors.phone = phoneValid ? '' : '無効な電話番号';
        break;

      case 'stationName':
        stationNameValid = !!stationName.trim();
        fieldValidationErrors.stationName = stationNameValid
          ? ''
          : '最寄りの駅名を入力してください';
        break;
      case 'way':
        wayValid = !!way;
        fieldValidationErrors.way = wayValid
          ? way.length < 5
            ? '方法は5文字でなければなりません'
            : ''
          : 'アクセスを入力してください';
        break;
      case 'workTime':
        workTimeValid = !!workTime;
        // validate the range
        const validity = validRange(value.startTime, value.endTime, false);
        console.log('TCL: _validateField -> validity', validity);
        if (validity === 'equal') {
          fieldValidationErrors.workTime = workTimeValid ? '' : '稼働時間を入力してください';
        } else if (validity === 'greater') {
          fieldValidationErrors.workTime = workTimeValid ? '' : '稼働時間を入力してください';
        } else {
          fieldValidationErrors.workTime = '';
        }
        break;
      case 'image':
        imageValid = !!image;
        fieldValidationErrors.image = imageValid ? '' : '適切な画像を選択';
        break;
      case 'description':
        descriptionValid = !!description;
        fieldValidationErrors.description = descriptionValid
          ? description.length < 5
            ? '説明は5文字でなければなりません'
            : ''
          : '説明は空ではない必要があります';
        break;
      case 'picTitle':
        picTitleValid = !!picTitle;
        fieldValidationErrors.picTitle = picTitleValid ? '' : '代表者役職を入力してください。';
        break;
      case 'picName':
        picNameValid = !!picName;
        fieldValidationErrors.picName = picNameValid ? '' : '代表者氏名を入力してください。';
        break;
      case 'chargePersonName':
        chargePersonNameValid = !!chargePersonName;
        fieldValidationErrors.chargePersonName = chargePersonNameValid
          ? ''
          : '担当者の名前を入力してください。';
        break;
      default:
        break;
    }
    this.setState(
      {
        formErrors: fieldValidationErrors,
        categoryValid,
        enterpriseNameValid,
        postCodeValid,
        emailValid,
        prefectureValid,
        cityValid,
        blockValid,
        streetValid,
        phoneValid,
        wayValid,
        workTimeValid,
        descriptionValid,
        imageValid,
        stationNameValid,
        picTitleValid,
        picNameValid,
        chargePersonNameValid
      },
      this.validateForm
    );
  };

  validateForm() {
    const {
      categoryName,
      categoryId,
      enterpriseName,
      postCode,
      email,
      street,
      phone,
      way,
      workTime,
      description,
      image,
      picTitle,
      picName,
      chargePersonName,
      formErrors,
      categoryValid,
      enterpriseNameValid,
      postCodeValid,
      emailValid,
      streetValid,
      phoneValid,
      wayValid,
      workTimeValid,
      descriptionValid,
      imageValid,
      allValid,
      stationName,
      stationNameValid,
      picTitleValid,
      picNameValid,
      chargePersonNameValid
    } = this.state;

    if (
      !!categoryId &&
      !!enterpriseName &&
      !!postCode &&
      postCode.length >= 7 &&
      !!email &&
      !!street &&
      !!phone &&
      !!way &&
      !!workTime &&
      !!description &&
      !!stationName &&
      !!image &&
      !!picTitle &&
      !!picName &&
      !!chargePersonName &&
      workTimeValid
    ) {
      this.setState({ allValid: true });
    } else {
      this.setState({ allValid: false });
    }
  }

  setContractValue = e => {
    this.fillContractValue(e.target.name, e.target.value);
  };

  fillContractValue = (name, value) => {
    this.setState({ [name]: value }, () => {
      this._validateContractField(name, value);
    });
  };

  _validateContractField = (fieldName, value) => {
    let { contractName, serviceUsed, formErrors } = this.state;
    const fieldValidationErrors = formErrors;

    switch (fieldName) {
      case 'contractName':
        fieldValidationErrors.contractName =
          contractName.length > 0 ? '' : '契約名を入力してください';
        break;
      case 'serviceUsed':
        fieldValidationErrors.serviceUsed =
          serviceUsed.length > 0 ? '' : '開始日を入力してください';
        break;
    }
    this.setState(
      {
        formErrors: fieldValidationErrors
      },
      this.validateForm
    );
  };

  validateForm() {
    const { contractName, serviceUsed } = this.state;

    if (!!contractName && !!serviceUsed) {
      this.setState({ allValidPlan: true });
    } else {
      this.setState({ allValidPlan: false });
    }
  }

  _errorClass(error) {
    if (error !== undefined) {
      return error.length === 0 ? '' : 'has-error';
    }
  }

  _renderPreviewImage = () => {
    const hasImage = this.state.image !== '';
    return (
      <div className="image-wrap">
        <div
          ref="image"
          className={
            hasImage ? 'img-fluid task-preview-image' : 'img-fluid task-preview-image hidden'
          }
          style={{ backgroundImage: `url(${this.state.image})` }}
        />
        <span className={hasImage ? 'hidden' : ''}>
          ここに画像が表示されます。
          <br />
          （画像サイズは600 * 500である必要があります）
        </span>
      </div>
    );
  };

  onImageSelected = e => {
    const file = e.target.files[0];
    const fr = new FileReader();

    fr.onload = () => {
      const imgNode = this.refs.image;
      imgNode.src = fr.result;
      this.setState({ image: fr.result }, () => {
        this.validateForm();
      });
    };
    if (file === undefined) {
      this.setState({ image: '' }, () => {
        this.validateForm();
      });
    } else {
      fr.readAsDataURL(file);
    }
  };

  _sendSetting = flag => {
    switch (flag) {
      case 1:
        const { allValid } = this.state;
        if (allValid) {
          const params = this.generateParams(flag);
          console.log('TCL: _sendSetting -> params', params);
          const token = this.currentUser.accessToken;
          this.props.updateSetting(params, token);
        }
        break;
      case 2:
        const { allValidPlan } = this.state;
        if (allValidPlan) {
          const params = this.generateParams(flag);
          console.log('TCL: _sendSetting -> params', params);
          const token = this.currentUser.accessToken;
          this.props.updateSetting(params, token);
        }
        break;

      default:
        break;
    }
  };

  generateParams = flag => {
    const {
      categories,
      categoryId,
      enterpriseName,
      postCode,
      email,
      prefecture,
      city,
      block,
      street,
      phone,
      way,
      workTime,
      image,
      description,
      stationName,
      picTitle,
      picName,
      nonBusinessHour,
      chargePersonName,
      contractName,
      serviceUsed,
      start_year,
      start_month,
      start_date
    } = this.state;
    const categoryObj = categories.find(cat => cat.key === categoryId);

    console.log('categoryId', categoryObj);
    var params;
    switch (flag) {
      case 1:
        params = {
          code: 'set_profile',
          email: this.currentUser.email,
          enterpriseId: this.currentUser.enterpriseId,
          enterprisePhotoId: image,
          categoryName: categoryObj.value,
          categoryId,
          enterpriseName,
          postCode,
          prefecture,
          city,
          block,
          street,
          phone,
          way,
          workTime: `${Moment(this.state.startTime).format('HH:mm')} - ${Moment(
            this.state.endTime
          ).format('HH:mm')}`,
          description,
          stationName,
          picTitle,
          picName,
          nonBusinessHour,
          chargePersonName
        };
        break;

      case 2:
        params = {
          code: 'set_contract_profile',
          email: this.currentUser.email,
          enterpriseId: this.currentUser.enterpriseId,
          contractName,
          contractStartDate: `${start_year}/${start_month}/${start_date}`,
          serviceUsed
        };
        break;

      default:
        break;
    }
    return params;
  };

  parsePostalCode = async e => {
    this.setState({ prefecture: '', city: '', block: '' });
    if (e.target.value.length >= 7) {
      await addressFromPostalCode(e.target.value).then(address => {
        console.log('TCL: address', address);
        this.setState(
          {
            prefecture: address.prefecture ? address.prefecture : '',
            city: address.city ? address.city : '',
            block: address.area ? address.area : ''
          },
          () => {
            this.validateForm();
          }
        );
      });
    }
  };

  _cancel = e => {
    this.props.modalCloseInAuth();
  };

  _moveToTop = () => {
    this.props.modalCloseInAuth();
    this.props.history.push(RT.TOP_PATH);
  };

  _onChangeTime = (flag, e) => {
    console.log('TCL: e', e);
    if (flag === '1') {
      this.setState(
        {
          startTime: e.startTime
        },
        () => {
          this.validateTime(this.state.startTime, this.state.endTime);
        }
      );
    } else if (flag === '2') {
      this.setState(
        {
          endTime: e.endTime
        },
        () => {
          this.validateTime(this.state.startTime, this.state.endTime);
        }
      );
    }
  };

  validateTime = (startTime, endTime) => {
    var { formErrors, workTime, workTimeValid } = this.state;
    const fieldValidationErrors = formErrors;

    ////
    workTimeValid = !!workTime;
    // validate the range
    const validity = validRange(startTime, endTime, false);
    console.log('TCL: _validateField -> validity', validity);
    if (validity === 'equal') {
      workTimeValid = false;
      fieldValidationErrors.workTime = workTimeValid
        ? ''
        : '有効な時間を入力してください。開始時間と終了時間を等しくすることはできません';
    } else if (validity === 'greater') {
      workTimeValid = false;
      fieldValidationErrors.workTime = workTimeValid
        ? ''
        : '有効な時間を入力してください。終了時刻を開始時刻より前にすることはできません。';
    } else {
      workTimeValid = true;
      fieldValidationErrors.workTime = '';
    }
    this.setState(
      {
        formErrors: fieldValidationErrors,
        workTimeValid
      },
      this.validateForm
    );
  };

  _renderYears = () => {
    return this.state.years.map(year => {
      return (
        <option key={year.key} value={year.value}>
          {year.label}
        </option>
      );
    });
  };

  _renderMonths = () => {
    return this.state.months.map(month => {
      return (
        <option key={month.key} value={month.value}>
          {month.label}
        </option>
      );
    });
  };

  _renderDays = () => {
    return this.state.days.map(day => {
      return (
        <option key={day.key} value={day.value}>
          {day.label}
        </option>
      );
    });
  };

  render = () => {
    const {
      categories,
      enterpriseName,
      postCode,
      email,
      prefecture,
      city,
      block,
      street,
      phone,
      way,
      workTime,
      formErrors,
      allValid,
      categoryId,
      stationName,
      picTitle,
      picName,
      nonBusinessHour,
      chargePersonName,
      pageTab,
      allValidPlan,
      contractName,
      serviceUsed
    } = this.state;
    return (
      <Template>
        <Modal
          isOpen={this.props.App.modalOpen}
          closeModal={this.props.modalCloseInAuth}
          headerTitle="設定更新"
          okClickHandler={null}
        >
          <div>{this.props.App.modalText}</div>
          <div className="text-center mt-4 col-md">
            <span className="btn btn-primary" onClick={this._moveToTop}>
              トップへ戻る
            </span>
          </div>
          <div className="text-center mt-4 col-md">
            <span className="btn btn-info" onClick={this._cancel}>
              閉じる
            </span>
          </div>
        </Modal>
        <div className="edit-main-block">
          <h2>事業者情報</h2>
          <div>
            <button onClick={() => this.setState({ pageTab: 1 })}>事業者情報</button>
            <button onClick={() => this.setState({ pageTab: 2 })}> 契約内容</button>
          </div>
          <h3 className="sub-title">
            事業者情報を管理します。タスクを投稿した際に表示される事業者情報となります。
            <br />
            連絡先のメールアドレスや電話番号はタスケルワーカーからタスクに関する問い合わせで使用されます。
          </h3>
          {pageTab == 1 ? (
            <div className="row">
              <div className="col-sm-4">
                <div className="form-group">
                  <label htmlFor="image">アイキャッチ画像</label>
                  <div className="edit-img-block">
                    {this._renderPreviewImage()}
                    <label class="custom-file-upload">
                      <input
                        type="file"
                        accept="image/*"
                        onChange={this.onImageSelected}
                        className={`form-control ${this._errorClass(formErrors.image)} imageFile`}
                      />
                      <label class="green-button">画像選択</label>
                      <span>施設写真を選択する</span>
                    </label>
                    <label className="error_text">{formErrors.image}</label>
                  </div>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="form-row">
                  <div className="form-group col-sm-5">
                    <label htmlFor="enterpriseName">事業者名</label>
                    <input
                      type="text"
                      className={`form-control ${this._errorClass(formErrors.enterpriseName)}`}
                      id="enterpriseName"
                      name="enterpriseName"
                      placeholder="未入力"
                      value={enterpriseName}
                      onChange={this.setValue}
                    />
                    <label className="error_text">{formErrors.enterpriseName}</label>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-sm-3">
                    <label htmlFor="category">事業者カテゴリ</label>
                    <div>
                      <select
                        className={`form-select ${this._errorClass(formErrors.categoryId)}`}
                        name="categoryId"
                        id="categoryId"
                        onChange={this.setValue}
                        value={categoryId}
                      >
                        <option value="" key="0" />
                        {this.renderEnterpriseCategoriesOptions(categories)}
                      </select>
                      <label className="error_text">{formErrors.categoryId}</label>
                    </div>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-sm-2">
                    <label htmlFor="postCode">郵便番号</label>
                    <input
                      type="text"
                      name="postCode"
                      className={`form-control ${this._errorClass(formErrors.postCode)}`}
                      id="postCode"
                      placeholder="未入力"
                      maxLength={7}
                      value={postCode}
                      onChange={this.setValue}
                      onBlur={this.parsePostalCode}
                    />
                    <label className="error_text">{formErrors.postCode}</label>
                  </div>
                  <div className="form-group col-sm-2">
                    <label htmlFor="prefecture">都道府県</label>
                    <input
                      type="text"
                      className="form-control"
                      id="prefecture"
                      name="prefecture"
                      readOnly
                      defaultValue={prefecture}
                    />
                  </div>
                  <div className="form-group col-sm-2">
                    <label htmlFor="city">市区町村</label>
                    <input
                      type="text"
                      className="form-control"
                      id="city"
                      readOnly
                      defaultValue={city}
                    />
                  </div>
                  <div className="form-group col-sm-2">
                    <label htmlFor="block">地名</label>
                    <input
                      type="text"
                      className="form-control"
                      id="block"
                      name="block"
                      readOnly
                      defaultValue={block}
                    />
                  </div>
                  <div className="form-group col-sm-3">
                    <label htmlFor="street">番地</label>
                    <input
                      type="text"
                      className={`form-control ${this._errorClass(formErrors.street)}`}
                      id="street"
                      name="street"
                      name="street"
                      placeholder="通り"
                      value={street}
                      onChange={this.setValue}
                    />
                    <label className="error_text">{formErrors.street}</label>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-sm-4">
                    <label htmlFor="way">アクセス</label>
                    <input
                      type="text"
                      className={`form-control ${this._errorClass(formErrors.way)}`}
                      id="way"
                      name="way"
                      placeholder="未入力"
                      value={way}
                      onChange={this.setValue}
                    />
                    <label className="error_text">{formErrors.way}</label>
                  </div>
                  <div className="form-group col-sm-4">
                    <label htmlFor="stationName">最寄駅</label>
                    <input
                      type="text"
                      className={`form-control ${this._errorClass(formErrors.stationName)}`}
                      id="stationName"
                      name="stationName"
                      placeholder="未入力"
                      value={stationName && stationName.trim()}
                      onChange={this.setValue}
                    />
                    <label className="error_text">{formErrors.stationName}</label>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-sm-4 operationtime-block">
                    <label htmlFor="workTime">営業時間</label>
                    <TimeRange
                      startMoment={this.state.startTime}
                      endMoment={this.state.endTime}
                      onChange={this._onChangeTime}
                      onStartTimeChange={e => {
                        console.log('TCL: render -> e', e);
                        this._onChangeTime('1', e);
                      }}
                      onEndTimeChange={e => {
                        console.log('TCL: render -> e', e);
                        this._onChangeTime('2', e);
                      }}
                      startLabel={''}
                      endLabel={''}
                      minuteIncrement={15}
                      use24Hours={true}
                      sameIsValid={false}
                      showErrors={false}
                    />
                    <label className="error_text">{formErrors.workTime}</label>
                  </div>
                  <div className="form-group col-sm-3">
                    <label htmlFor="stationName">休日</label>
                    <input
                      type="text"
                      className={`form-control ${this._errorClass(formErrors.stationName)}`}
                      id="nonBusinessHour"
                      name="nonBusinessHour"
                      placeholder="未入力"
                      value={nonBusinessHour && nonBusinessHour.trim()}
                      onChange={this.setValue}
                    />
                    <label className="error_text">{formErrors.nonBusinessHour}</label>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-sm-3">
                    <label htmlFor="picName">代表者氏名</label>
                    <Tooltip content="tooltip">
                      <i className="fas fa-info-circle" />
                    </Tooltip>
                    <input
                      type="text"
                      className={`form-control ${this._errorClass(formErrors.picName)}`}
                      id="picName"
                      name="picName"
                      placeholder="未入力"
                      value={picName}
                      onChange={this.setValue}
                    />
                    <label className="error_text">{formErrors.picName}</label>
                  </div>
                  <div className="form-group col-sm-3">
                    <label htmlFor="picTitle">代表者役職 </label>
                    <Tooltip content="tooltip">
                      <i className="fas fa-info-circle" />
                    </Tooltip>
                    <input
                      type="text"
                      className={`form-control ${this._errorClass(formErrors.picTitle)}`}
                      id="picTitle"
                      name="picTitle"
                      placeholder="未入力"
                      value={picTitle}
                      onChange={this.setValue}
                    />
                    <label className="error_text">{formErrors.picTitle}</label>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-sm-3">
                    <label htmlFor="chargePersonName">担当者氏名</label>
                    <Tooltip content="tooltip">
                      <i className="fas fa-info-circle" />
                    </Tooltip>
                    <input
                      type="text"
                      className={`form-control ${this._errorClass(formErrors.chargePersonName)}`}
                      id="chargePersonName"
                      name="chargePersonName"
                      placeholder="担当者氏名"
                      value={chargePersonName}
                      onChange={this.setValue}
                    />
                    <label className="error_text">{formErrors.chargePersonName}</label>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-sm-4">
                    <label htmlFor="email">メールアドレス</label>
                    <Tooltip content="tooltip">
                      <i className="fas fa-info-circle" />
                    </Tooltip>
                    <input
                      type="text"
                      className={`form-control ${this._errorClass(formErrors.email)}`}
                      id="email"
                      name="email"
                      placeholder="未入力"
                      value={email}
                      disabled={true}
                      onChange={this.setValue}
                    />
                    <label className="error_text">{formErrors.email}</label>
                  </div>
                  <div className="form-group col-sm-4">
                    <label htmlFor="phone">電話番号</label>
                    <Tooltip content="tooltip">
                      <i className="fas fa-info-circle" />
                    </Tooltip>
                    <input
                      type="text"
                      className={`form-control ${this._errorClass(formErrors.phone)}`}
                      id="phone"
                      name="phone"
                      placeholder="未入力"
                      value={phone}
                      maxLength={11}
                      onChange={this.setValue}
                    />
                    <label className="error_text">{formErrors.phone}</label>
                  </div>
                </div>
              </div>
            </div>
          ) : (
              <div className="row">
                <div className="col-sm-8">
                  <div className="form-row">
                    <div className="form-group col-sm-5">
                      <label htmlFor="enterpriseName">ご契約プラン</label>
                      <input
                        type="text"
                        className={`form-control ${this._errorClass(formErrors.contractName)}`}
                        id="contractName"
                        name="contractName"
                        placeholder="ご契約プラン"
                        value={contractName}
                        onChange={this.setContractValue}
                      />
                      <label className="error_text">{formErrors.contractName}</label>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group col-sm-5">
                      <label htmlFor="enterpriseName">契約開始日</label>
                      <div>
                        <select
                          className="form-select"
                          name="start_year"
                          id="start_year"
                          onChange={this.setValue}
                          value={this.state.start_year}
                        >
                          {this._renderYears()}
                        </select>
                        <select
                          className="form-select"
                          name="start_month"
                          id="start_month"
                          onChange={this.setValue}
                          value={this.state.start_month}
                        >
                          {this._renderMonths()}
                        </select>
                        <select
                          className="form-select"
                          name="start_date"
                          id="start_date"
                          onChange={this.setValue}
                          value={this.state.start_date}
                        >
                          {this._renderDays()}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="col-sm-12 facility-block">
                      <label htmlFor="description">ご利用サービス内容</label>
                      <textarea
                        className={`form-control ${this._errorClass(formErrors.serviceUsed)}`}
                        style={{ height: '200px' }}
                        name="serviceUsed"
                        id="serviceUsed"
                        onChange={this.setContractValue}
                        value={serviceUsed}
                      />
                      <label className="error_text">{formErrors.serviceUsed}</label>
                    </div>
                  </div>
                  <div className="col-sm-12 setting-edit-button">
                    <button
                      type="button"
                      className="btn btn-success float-right"
                      onClick={() => this._sendSetting(2)}
                      disabled={!allValidPlan}
                    >
                      更新する
                  </button>
                  </div>
                </div>
              </div>
            )}
          {pageTab == 1 && (
            <div className="row">
              <div className="col-sm-12 facility-block">
                <label htmlFor="description">施設の紹介文</label>
                <textarea
                  className={`form-control ${this._errorClass(formErrors.description)}`}
                  style={{ height: '200px' }}
                  name="description"
                  id="description"
                  onChange={this.setValue}
                  value={this.state.description}
                />
                <label className="error_text">{formErrors.description}</label>
              </div>
              <div className="col-sm-12 setting-edit-button">
                <button
                  type="button"
                  className="btn btn-success float-right"
                  onClick={() => this._sendSetting(1)}
                  disabled={!allValid}
                >
                  更新する
                </button>
              </div>
            </div>
          )}
        </div>
      </Template>
    );
  };
}

const mapStateToProps = state => state;
const mapDispatchToProps = dispatch => bindActionCreators(Actions, dispatch);

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default withRouter(Container);
